import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

function getDefaultState() {
    return {
        selectedDoctor: {},
        selectedCase: {},
        showCaseDetails: false,
        showAssignCaseToDoctor: false,
        showCreateCasePMS: false,
        showAssignCaseToDoctorList: false,
        cases: [],
        
        search_items: [],
        pms_case_search: "",
        selected_search_case: null,
        selectedPatient: {},
        isImagesRetrieved: false,
        // showPatientPMSCase: false
    }
}

export default new Vuex.Store({
    state: getDefaultState(),
    mutations: {
        
        setSeachItems(state, payload) {
            state.search_items = payload;
        },

        setCaseSearch(state, payload) {
            state.pms_case_search = payload;
        },

        setSelectedSearchCase(state, payload) {
            state.selected_search_case = payload;
        },

        setSelectedPatient(state, payload) {
            state.selectedPatient = payload;
        },

        setIsImagesRetrieved(state, payload) {
            state.isImagesRetrieved = payload;
        },

        

        setSelectedCase(state, payload) {
            state.selectedCase = payload;
        },

        resetState(state) {
            Object.assign(
                state,
                getDefaultState()
            );
        },
        showCaseDetails(state, payload) {
            state.showCaseDetails = payload;
        },
        showAssignCaseToDoctor(state, payload) {
            state.showAssignCaseToDoctor = payload;
        },
        setSelectedDoctor(state, payload) {
            state.selectedDoctor = payload;
        },
        showCreateCasePMS(state, payload) {
            state.showCreateCasePMS = payload;
        },

        // showPatientPMSCase(state, payload) {
        //     state.showPatientPMSCase = payload;
        // },
        showAssignCaseToDoctorList(state, payload) {
            state.showAssignCaseToDoctorList = payload;
        },
        setCases(state, payload) {
            state.cases = payload;
        },
        addToLastCases(state, payload) {
            state.cases.push(payload);
        },
        placeToCases(state, payload) {
            state.cases.splice(payload.index || 0, 0, payload.case || payload);
            console.log("SOCKET_DEBUG", "New case list", { caseList: state.cases })
        },
        removeToCases(state, payload) {
            if (Number.isInteger(payload.index)) {
                state.cases.splice(payload.index, 1);
            }
        }
    },
    actions: {
        setSelectedCase(context, payload) {
            context.commit("setSelectedCase", payload);
        },
        setSelectedDoctor(context, payload) {
            context.commit("setSelectedDoctor", payload);
        },
        resetState(context) {
            context.commit("resetState");
        },
        
        assignCaseToDoctor(context, payload) {

            console.log("case being assigned to doctor");
            console.log(payload);

            context.commit("setSelectedCase", payload.case);
            context.commit("setSelectedDoctor", payload.doctor);
            context.commit("showAssignCaseToDoctor", true);
        },

        setCases(context, payload) {
            context.commit("setCases", payload);
        }
    },
    getters: {
        showCaseDetails: state => {
            return state.showCaseDetails;
        },

        showSeachItems: state => {
            return state.search_items;
        },

        showSelectedSearchCase: state => {
            return state.selected_search_case;
        },

        showSelectedPatient: state => {
            return state.selectedPatient;
        },

        showIsImagesRetrieved: state => {
            return state.isImagesRetrieved;
        },



        showCaseSearch: state => {
            return state.pms_case_search;
        },

        selectedCase: state => {
            return state.selectedCase;
        },
        showAssignCaseToDoctor: state => {
            return state.showAssignCaseToDoctor;
        },
        selectedDoctor: state => {
            return state.selectedDoctor;
        },
        showCreateCasePMS: state => {
            return state.showCreateCasePMS;
        },
        showAssignCaseToDoctorList: state => {
            return state.showAssignCaseToDoctorList;
        },
        cases: state => {
            return state.cases;
        }
        // showPatientPMSCase: state => {
        //     return state.showPatientPMSCase;
        // }
    },
    modules: {}
  });